import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { adminMainUrl } from '../../../../../../Config';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderTransportDeliverBranchList, getJobOrderTransportDetail, getJobOrderTransportPickupBranchList, getJobOrderTransportTransporterBranchList } from '../../../../../../Redux/action/Joborder/JoborderAction';
import { convertDateTimeToApiFormatInJobOrderTransport, convertToDatetimeLocalFormatInJobOrderTransport } from '../../../../../../HelperFunctions';
import Beatloader from '../../../../../../Common/Loaders/Beatloader';

const EditTransport = ({
    showAdd,
    handleCloseAdd,
    token,
    user_id,
    b64id,
    transmode,
    transtype,
    loadingJobOrderCFSList,
    JobOrderCFSListError,
    JobOrderCFSList,
    loadingJobOrderCustomerList,
    JobOrderCustomerList,
    JobOrderCustomerListError,
    refreshTransport,
    transport_id
}) => {

    // console.log("transmode", transmode, "transtype", transtype);
    const [showLoader, setShowLoader] = useState(false);
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);


    useEffect(() => {
        if (token && user_id && b64id && transport_id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderTransportDetail(token, user_id, id, transport_id))
            }
        }
    }, [transport_id]);

    let {
        loadingJobOrderTransportDetail,
        JobOrderTransportDetailError,
        JobOrderTransportDetail,
    } = useSelector(state => state?.JoborderReducer);





    const initialValues = {
        job_order_id: "",
        DI_type: "",
        pickup_from_type: "",
        pickup_from_id: "",
        pickup_from_name: "",
        pickup_address_id: "",
        pickup_address: "",
        EST_date_time_for_pickup_input: "",
        deliver_from_type: "",
        deliver_from_id: "",
        deliver_from_name: "",
        deliver_address_id: "",
        deliver_address: "",
        EST_date_time_for_deliver_input: "",
        transporter_id: "",
        transporter_address: "",
        transporter_ref_no: "",
        total_package: "",
        total_weight: "",
        total_volume: "",
        container_no: "",
        remark: "",
        vehicle_no: "",
        driver_name: "",
        charge_type: ""
    };


    let [CFSOptions, setCFSOptions] = useState([]);

    useEffect(() => {
        if (JobOrderCFSList) {
            let arr = [];
            JobOrderCFSList.map((val) => {
                arr.push({ value: val.id, label: val.name })
            });
            setCFSOptions(arr);
        }
    }, [loadingJobOrderCFSList, JobOrderCFSList]);

    let [OrganisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (JobOrderCustomerList) {
            let arr = [];
            JobOrderCustomerList.map((val) => {
                arr.push({ value: val.id, label: val.name })
            });
            setOrganisationOptions(arr);
        }
    }, [loadingJobOrderCustomerList, JobOrderCustomerList])

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            console.log(values.EST_date_time_for_deliver_input, values.EST_date_time_for_pickup_input);
            values.EST_date_time_for_deliver = convertDateTimeToApiFormatInJobOrderTransport(values.EST_date_time_for_deliver_input);
            values.EST_date_time_for_pickup = convertDateTimeToApiFormatInJobOrderTransport(values.EST_date_time_for_pickup_input);
            values.pickup_from_name = "Static Data" //static currently
            values.deliver_from_name = "Static Data" //static currently
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.job_order_id = atob(b64id);
                if (!transport_id) {
                    toast.error("Please enter correct transport id.");
                    return;
                } else {
                    values.id = transport_id;
                }
                axios.post(`${adminMainUrl}/api/jobOrder/transport/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // refreshFreightData();
                            handleCloseAdd();
                            refreshTransport();

                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal Server Error!"
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg;
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const [showOrganisationField, setShowOrganisationField] = useState(false);
    useEffect(() => {
        if (formik.values.pickup_from_type == "Organisation") {
            setShowOrganisationField(true);
        } else {
            setShowOrganisationField(false);
        }
    }, [formik.values.pickup_from_type]);



    //set data on form
    useEffect(() => {
        if (loadingJobOrderTransportDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (JobOrderTransportDetail) {
            // console.log(JobOrderTransportDetail,"===>",convertToDatetimeLocalFormatInJobOrderTransport(JobOrderTransportDetail?.EST_date_time_for_pickup_input),"===>",convertToDatetimeLocalFormatInJobOrderTransport(JobOrderTransportDetail?.EST_date_time_for_deliver_input));
            formik.setFieldValue("DI_type", JobOrderTransportDetail?.DI_type);
            formik.setFieldValue("pickup_from_type", JobOrderTransportDetail?.pickup_from_type);
            formik.setFieldValue("pickup_from_id", Number(JobOrderTransportDetail?.pickup_from_id));
            if (JobOrderTransportDetail?.pickup_from_id) {
                handleGetPickupBranch(JobOrderTransportDetail?.pickup_from_id);
            }
            formik.setFieldValue("pickup_from_name", Number(JobOrderTransportDetail?.pickup_from_name));
            formik.setFieldValue("pickup_address_id", Number(JobOrderTransportDetail?.pickup_address_id));
            formik.setFieldValue("pickup_address", JobOrderTransportDetail?.pickup_address);
            // formik.setFieldValue("EST_date_time_for_pickup_input", "2025-01-02T07:32");
            formik.setFieldValue("EST_date_time_for_pickup_input", convertToDatetimeLocalFormatInJobOrderTransport(JobOrderTransportDetail?.EST_date_time_for_pickup));
            formik.setFieldValue("deliver_from_type", JobOrderTransportDetail?.deliver_from_type);
            formik.setFieldValue("deliver_from_id", Number(JobOrderTransportDetail?.deliver_from_id));
            if (JobOrderTransportDetail?.deliver_from_id) {
                handleGetDeliverBranch(JobOrderTransportDetail?.deliver_from_id);
            }
            formik.setFieldValue("deliver_from_name", Number(JobOrderTransportDetail?.deliver_from_name));
            formik.setFieldValue("deliver_address_id", Number(JobOrderTransportDetail?.deliver_address_id));
            formik.setFieldValue("deliver_address", JobOrderTransportDetail?.deliver_address);
            formik.setFieldValue("EST_date_time_for_deliver_input", convertToDatetimeLocalFormatInJobOrderTransport(JobOrderTransportDetail?.EST_date_time_for_deliver));
            formik.setFieldValue("transporter_id", Number(JobOrderTransportDetail?.transporter_id));
            if (JobOrderTransportDetail?.transporter_id) {
                handleGetTransporterBranch(JobOrderTransportDetail?.transporter_id);
            }
            formik.setFieldValue("transporter_address", Number(JobOrderTransportDetail?.transporter_address));
            formik.setFieldValue("transporter_ref_no", JobOrderTransportDetail?.transporter_ref_no);
            formik.setFieldValue("total_package", JobOrderTransportDetail?.total_package);
            formik.setFieldValue("total_weight", JobOrderTransportDetail?.total_weight);
            formik.setFieldValue("total_volume", JobOrderTransportDetail?.total_volume);
            formik.setFieldValue("container_no", JobOrderTransportDetail?.container_no);
            formik.setFieldValue("remark", JobOrderTransportDetail?.remark);
            formik.setFieldValue("vehicle_no", JobOrderTransportDetail?.vehicle_no);
            formik.setFieldValue("driver_name", JobOrderTransportDetail?.driver_name);
            formik.setFieldValue("charge_type", JobOrderTransportDetail?.charge_type);
        }
    }, [
        loadingJobOrderTransportDetail,
        JobOrderTransportDetailError,
        JobOrderTransportDetail
    ])

    const {
        loadingJobOrderTransportPickupBranchList,
        JobOrderTransportPickupBranchListError,
        JobOrderTransportPickupBranchList,

        loadingJobOrderTransportDeliverBranchList,
        JobOrderTransportDeliverBranchListError,
        JobOrderTransportDeliverBranchList,


        loadingJobOrderTransportTransporterBranchList,
        JobOrderTransportTransporterBranchListError,
        JobOrderTransportTransporterBranchList,

    } = useSelector(state => state?.JoborderReducer);
    //pickup branch
    const handleGetPickupBranch = (branch_id) => {
        try {
            if (token && user_id && branch_id) {
                dispatch(getJobOrderTransportPickupBranchList(token, user_id, branch_id));
            }
        } catch (error) {
            console.log("Error in handleGetPickupBranch function:", error.message);
        }
    };

    const [pickupBranchOptions, setPickupBranchOptions] = useState([]);



    useEffect(() => {
        if (JobOrderTransportPickupBranchList) {
            let arr = [];
            JobOrderTransportPickupBranchList.map(val => {
                arr.push({ value: val.id, label: val.branch_name })
            });
            setPickupBranchOptions(arr);
            // console.log("JobOrderTransportPickupBranchList", JobOrderTransportPickupBranchList)
        }
    }, [JobOrderTransportPickupBranchList])


    //deliver branch
    const handleGetDeliverBranch = (branch_id) => {
        try {
            if (token && user_id && branch_id) {
                dispatch(getJobOrderTransportDeliverBranchList(token, user_id, branch_id));
            }
        } catch (error) {
            console.log("Error in handleGetDeliverBranch function:", error.message);
        }
    };

    const [deliverBranchOptions, setDeliverBranchOptions] = useState([]);

    useEffect(() => {
        if (JobOrderTransportDeliverBranchList) {
            let arr = [];
            JobOrderTransportDeliverBranchList.map(val => {
                arr.push({ value: val.id, label: val.branch_name })
            });
            setDeliverBranchOptions(arr);
            // console.log("JobOrderTransportDeliverBranchList", JobOrderTransportDeliverBranchList)
        }
    }, [JobOrderTransportDeliverBranchList])


    //Transporter branch
    const handleGetTransporterBranch = (branch_id) => {
        try {
            if (token && user_id && branch_id) {
                dispatch(getJobOrderTransportTransporterBranchList(token, user_id, branch_id));
            }
        } catch (error) {
            console.log("Error in handleGetTransporterBranch function:", error.message);
        }
    };

    const [transporterBranchOptions, setTransporterBranchOptions] = useState([]);

    useEffect(() => {
        if (JobOrderTransportTransporterBranchList) {
            let arr = [];
            JobOrderTransportTransporterBranchList.map(val => {
                arr.push({ value: val.id, label: val.branch_name })
            });
            setTransporterBranchOptions(arr);
            // console.log("JobOrderTransportTransporterBranchList", JobOrderTransportTransporterBranchList)
        }
    }, [JobOrderTransportTransporterBranchList]);

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };




    return (
        <>
            <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Transport</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        showLoader ?
                            <Beatloader />
                            :
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">

                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="pickuptype" className="form-label ">{transtype == "Import" ? "DI" : "Pickup"} Type</label>
                                        <select
                                            className='form-control form-control-sm'
                                            id="DI_type"
                                            name="DI_type"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.DI_type}
                                        >
                                            <option value="" disabled>-</option>
                                            <option value="Self" selected >Self</option>
                                            <option value={transtype == "Import" ? `Consignee Routed` : `Shipper Routed`}>{transtype == "Import" ? "Consignee" : "Shipper"} Routed</option>
                                            <option value="Carrier">Carrier</option>
                                        </select>
                                    </div>



                                    {/* <div className="col-md-6 mt-2">
                                        <label htmlFor="date" className="form-label ">Date</label>
                                        <input type="date" className='form-control form-control-sm' id="date"
                                            name="date"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.date}
                                        />
                                    </div> */}
                                    {/* <div className="col-md-6 mt-2">
                                        <label htmlFor="cargotype" className="form-label ">Empty Courier Pickup</label>
                                        <Select
                                            id="DestinationAgent"
                                            placeholder="Select Container Freight System"
                                            className='custom-selector w-100'
                                            styles={customStyles}
                                            options={CFSOptions}
                                            name="role_id"
                                            value={OrganisationOptions.find(option => option.value === formik.values.pickup_from_id) || null}
                                        />
                                    </div> */}
                                    {/* <div className="col-md-6 mt-2">
                                        <label htmlFor="bill_to" className="form-label ">Bill to</label>
                                        <Select
                                            id="bill_to"
                                            placeholder="Select Organisation"
                                            className='custom-selector w-100'
                                            options={OrganisationOptions}
                                            styles={customStyles}
                                            name="bill_to"
                                            onChange={option => {
                                                formik.setFieldValue('bill_to', option.value);
                                            }}
                                            value={OrganisationOptions.find(option => option.value === formik.values.bill_to) || null}

                                        />
                                    </div> */}
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="cargotype" className="form-label ">Pickup from</label>
                                        <select className='form-control form-control-sm'
                                            id="pickup_from_type"
                                            name="pickup_from_type"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.pickup_from_type}
                                        >
                                            <option value="" disabled>-</option>
                                            <option value="Organisation">Organisation</option>
                                            {transmode == "Sea" && <option value="CFS/YARD">CFS/YARD</option>}
                                            <option value="Pickup Address">Pickup Address</option>
                                        </select>
                                    </div>


                                    {/* Depend on the Sea & Air and Pickup from type */}
                                    {formik.values.pickup_from_type == "Pickup Address" && <div className="col-md-6 mt-2">
                                        <label htmlFor="goodsexpecteddate" className="form-label ">Pickup Address</label>
                                        <textarea name="pickup_address" id="pickup_address" className='form-control' rows={2}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.pickup_address}
                                        ></textarea>

                                    </div>
                                    }
                                    {formik.values.pickup_from_type == "Organisation" &&
                                        <>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Pickup Address</label>
                                                <Select
                                                    id="pickup_from_id"
                                                    placeholder="Select Organisation"
                                                    className='custom-selector w-100'
                                                    options={OrganisationOptions}
                                                    styles={customStyles}
                                                    name="pickup_from_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('pickup_from_id', option.value);
                                                        handleGetPickupBranch(option.value);
                                                    }}
                                                    value={OrganisationOptions.find(option => option.value === formik.values.pickup_from_id) || null}
                                                />

                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Select Branch</label>
                                                <Select
                                                    id="pickup_address_id"
                                                    placeholder="Select Organisation"
                                                    className='custom-selector w-100'
                                                    options={pickupBranchOptions}
                                                    styles={customStyles}
                                                    name="pickup_address_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('pickup_address_id', option.value);
                                                        formik.setFieldValue('pickup_address', option.label);
                                                    }}
                                                    value={pickupBranchOptions.find(option => option.value === formik.values.pickup_address_id) || null}
                                                    isLoading={loadingJobOrderTransportPickupBranchList}
                                                />

                                            </div>
                                        </>
                                    }
                                    {(transmode == "Sea" && formik.values.pickup_from_type == "CFS/YARD") &&
                                        <>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Pickup Address</label>
                                                <Select
                                                    id="pickup_from_id"
                                                    placeholder="Select CFS"
                                                    className='custom-selector w-100'
                                                    options={CFSOptions}
                                                    styles={customStyles}
                                                    name="pickup_from_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('pickup_from_id', option.value);
                                                        formik.setFieldValue('pickup_address', option.label);
                                                    }}
                                                    value={CFSOptions.find(option => option.value === formik.values.pickup_from_id) || null}
                                                />
                                            </div>
                                        </>
                                    }
                                    {/* Depend on the Sea & Air and Deliver  from type */}

                                    {/* Deliver to */}
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="cargotype" className="form-label ">Deliver To</label>
                                        <select className='form-control form-control-sm'
                                            id="deliver_from_type"
                                            name="deliver_from_type"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.deliver_from_type}
                                        >
                                            <option value="" disabled>-</option>
                                            <option value="Organisation">Organisation</option>
                                            {transmode == "Sea" && <option value="CFS/YARD">CFS/YARD</option>}
                                            <option value="Pickup Address">Pickup Address</option>
                                        </select>
                                    </div>


                                    {/* Depend on the Sea & Air and Pickup from type */}
                                    {formik.values.deliver_from_type == "Pickup Address" && <div className="col-md-6 mt-2">
                                        <label htmlFor="goodsexpecteddate" className="form-label ">Delivery Address</label>
                                        <textarea name="deliver_address" id="deliver_address" className='form-control' rows={2}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.deliver_address}
                                        ></textarea>

                                    </div>}

                                    {formik.values.deliver_from_type == "Organisation" &&
                                        <>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Delivery Address</label>
                                                <Select
                                                    id="deliver_from_id"
                                                    placeholder="Select Organisation"
                                                    className='custom-selector w-100'
                                                    options={OrganisationOptions}
                                                    styles={customStyles}
                                                    name="deliver_from_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('deliver_from_id', option.value);
                                                        handleGetDeliverBranch(option.value);
                                                    }}
                                                    value={OrganisationOptions.find(option => option.value === formik.values.deliver_from_id) || null}
                                                />

                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Delivery Branch</label>
                                                <Select
                                                    id="deliver_address_id"
                                                    placeholder="Select Organisation"
                                                    className='custom-selector w-100'
                                                    options={deliverBranchOptions}
                                                    styles={customStyles}
                                                    name="deliver_address_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('deliver_address_id', option.value);
                                                        formik.setFieldValue('deliver_address', option.label)
                                                    }}
                                                    value={deliverBranchOptions.find(option => option.value === formik.values.deliver_address_id) || null}
                                                    isLoading={loadingJobOrderTransportDeliverBranchList}
                                                />

                                            </div>
                                        </>
                                    }

                                    {(transmode == "Sea" && formik.values.deliver_from_type == "CFS/YARD") &&
                                        <>
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="goodsexpecteddate" className="form-label ">Delivery Address</label>
                                                <Select
                                                    id="deliver_from_id"
                                                    placeholder="Select CFS"
                                                    className='custom-selector w-100'
                                                    options={CFSOptions}
                                                    styles={customStyles}
                                                    name="deliver_from_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('deliver_from_id', option.value);
                                                        formik.setFieldValue('deliver_address', option.label)
                                                    }}
                                                    value={CFSOptions.find(option => option.value === formik.values.deliver_from_id) || null}
                                                />

                                            </div>
                                        </>
                                    }
                                    {/* Depend on the Sea & Air and Pickup from type */}

                                    {/* <div className="col-md-6 mt-2">
                                <label htmlFor="goodsexpecteddate" className="form-label ">Delivery Address</label>
                                <textarea name="" id="" className='form-control' rows={2}></textarea>
                            </div> */}
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">EST Date & Time(Pickup)</label>
                                        <input type="datetime-local"
                                            className='form-control form-control-sm'
                                            name="EST_date_time_for_pickup_input"
                                            id="EST_date_time_for_pickup_input"
                                            min={new Date().toISOString().slice(0, 16)} // Set min to current date and time
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.EST_date_time_for_pickup_input}
                                        />
                                    </div>

                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">EST Date & Time(Deliver)</label>
                                        <input
                                            type="datetime-local"
                                            className='form-control form-control-sm'
                                            name="EST_date_time_for_deliver_input"
                                            id="EST_date_time_for_deliver_input"
                                            min={new Date().toISOString().slice(0, 16)} // Set min to current date and time
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.EST_date_time_for_deliver_input}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="cargotype" className="form-label ">Transporter</label>
                                        <Select
                                            id="DestinationAgent"
                                            placeholder="Select Organisation"
                                            className='custom-selector w-100'
                                            options={OrganisationOptions}
                                            styles={customStyles}
                                            name="transporter_id"
                                            onChange={option => {
                                                formik.setFieldValue('transporter_id', option.value);
                                                handleGetTransporterBranch(option.value)
                                            }}
                                            value={OrganisationOptions.find(option => option.value === formik.values.transporter_id) || null}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="cargotype" className="form-label ">Transporter Branch</label>
                                        <Select
                                            id="DestinationAgent"
                                            placeholder="Select Branch Address"
                                            className='custom-selector w-100'
                                            options={transporterBranchOptions}
                                            styles={customStyles}
                                            name="transporter_address"
                                            onChange={option => {
                                                formik.setFieldValue('transporter_address', option.value);
                                            }}
                                            value={transporterBranchOptions.find(option => option.value === formik.values.transporter_address) || null}
                                            isLoading={loadingJobOrderTransportTransporterBranchList}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">Total Package</label>
                                        <input type="number"
                                            min={0}
                                            max={999999}
                                            className='form-control form-control-sm'
                                            name="total_package"
                                            id="total_package"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_package}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">Total Weight</label>
                                        <input type="number"
                                            min={0}
                                            max={999999}
                                            className='form-control form-control-sm'
                                            name="total_weight"
                                            id="total_weight"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_weight}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">Total Volume</label>
                                        <input type="number"
                                            min={0}
                                            max={999999}
                                            className='form-control form-control-sm'
                                            name="total_volume"
                                            id="total_volume"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_volume}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="transporter_ref_no" className="form-label ">Transporter Ref No.</label>
                                        <input type="text" name="transporter_ref_no" id="transporter_ref_no" className='form-control form-control-sm'
                                            maxLength={35}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.transporter_ref_no}
                                            onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">Vehicle No.</label>
                                        <input type="text" name="vehicle_no" id="vehicle_no" className='form-control form-control-sm'
                                            maxLength={35}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.vehicle_no}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="movementtype" className="form-label ">Driver Name</label>
                                        <input type="text" name="driver_name" id="driver_name" className='form-control form-control-sm'
                                            maxLength={150}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                // Replace everything except alphabets (a-z, A-Z), spaces, and periods (.)
                                                value = value.replace(/[^a-zA-Z .]/g, '');
                                                event.target.value = value;
                                            }}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.driver_name}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="charge_type" className="form-label ">Charge Type</label>
                                        <select className='form-control form-control-sm' id="charge_type"
                                            name='charge_type'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.charge_type}
                                        >
                                            <option value="" disabled>-</option>
                                            <option value="Prepaid" selected >Prepaid</option>
                                            <option value="Collection" >Collection</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="remark" className="form-label ">Remark</label>
                                        <textarea id="remark" className='form-control' rows={2}
                                            maxLength={250}
                                            name='remark'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.remark}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="row d-flex justify-content-end my-2">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                    }

                </Offcanvas.Body>
            </Offcanvas >
        </>
    )
}

export default EditTransport